const argFact = (compareFn: (minMax: number[], el: number[]) => number[]) => {
  return (array: number[]): number => {
    return array
      .map((el, idx) => {
        return [el, idx];
      })
      .reduce(compareFn)[1];
  };
};

export const argMax = argFact((min: number[], el: number[]) => {
  return el[0] > min[0] ? el : min;
});
export const argMin = argFact((max: number[], el: number[]) => {
  return el[0] < max[0] ? el : max;
});

export const numberWithCommas = (x: number): string => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
